import axios from 'axios';
import map from 'lodash/map';
import YAML from 'yaml';
import * as Sentry from '@sentry/react';

export const getWebforms = async () =>
	axios
		.get('/forms_rest_api/webform')
		.then(async ({ data }) => {
			if (data) {
				try {
					return map(data, webform => {
						const elements = YAML.parse(webform.elements);
						const tags = elements.form_tags['#value'].split(',').map(element => {
							const [name, order] = element.split('=');
							return {
								name,
								order
							};
						});

						return {
							uuid: webform.uuid,
							tags,
							template: webform.categories[0],
							elements,
							id: webform.id,
							title: webform.title,
							description: webform.description
						};
					});
				} catch (error) {
					error.extra = data;
					throw error;
				}
			} else {
				return [];
			}
		})
		.catch(error => {
			Sentry.captureException(error, { extra: error.extra });
			throw error;
		});
